// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AdminLoginController from "./admin_login_controller"
application.register("admin-login", AdminLoginController)

import AnnouncementFormController from "./announcement_form_controller"
application.register("announcement-form", AnnouncementFormController)

import BabySelectController from "./baby_select_controller"
application.register("baby-select", BabySelectController)

import DrawerController from "./drawer_controller"
application.register("drawer", DrawerController)

import LocaleSwitcherController from "./locale_switcher_controller"
application.register("locale-switcher", LocaleSwitcherController)

import MarkdownEditorController from "./markdown_editor_controller"
application.register("markdown-editor", MarkdownEditorController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import NotificationDropdownController from "./notification_dropdown_controller"
application.register("notification-dropdown", NotificationDropdownController)

import ReadingTrackerController from "./reading_tracker_controller"
application.register("reading-tracker", ReadingTrackerController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import SidebarNavController from "./sidebar_nav_controller"
application.register("sidebar-nav", SidebarNavController)

import TencentCaptchaController from "./tencent_captcha_controller"
application.register("tencent-captcha", TencentCaptchaController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import TurnstileCaptchaController from "./turnstile_captcha_controller"
application.register("turnstile-captcha", TurnstileCaptchaController)

import LandingDemoController from "./landing_demo_controller"
application.register("landing-demo", LandingDemoController)

import LanguageSelectorController from "./language_selector_controller"
application.register("language-selector", LanguageSelectorController)

import PasswordToggleController from "./password_toggle_controller"
application.register("password-toggle", PasswordToggleController)

import WebLoginController from "./web_login_controller"
application.register("web-login", WebLoginController)

import DeviceLoginController from "./device_login_controller"
application.register("device-login", DeviceLoginController)

import ChatController from "./chat_controller"
application.register("chat", ChatController)

import ChatRoomController from "./chat_room_controller"
application.register("chat-room", ChatRoomController)

import DebugPanelController from "./debug_panel_controller"
application.register("debug-panel", DebugPanelController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import RoomMembersController from "./room_members_controller"
application.register("room-members", RoomMembersController)
